import { render, staticRenderFns } from "./wireless.vue?vue&type=template&id=54694a5a&scoped=true"
import script from "./wireless.vue?vue&type=script&lang=js"
export * from "./wireless.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54694a5a",
  null
  
)

export default component.exports